import { AutoComplete, Form } from 'antd';
import styles from './index.module.scss';
import { useState } from 'react';

type FieldName =
	| 'medicineName'
	| 'manufacturer'
	| 'marketedBy'
	| 'weightage'
	| 'flavors'
	| 'offers'
	| 'usesTags'
	| 'productName'
	| 'brand'
	| 'manufacturerName'
	| 'storageInstructions'
	| 'fssaiLicenseNo'
	| 'hsnCode'
	| 'productCode'
	| 'shelfLife'
	| 'numberOfItems'
	| 'ingredients';

interface Props {
	singleUserInput: {
		name: FieldName;
		title: string;
		required?: boolean;
		placeHolder?: string;
		rules?: any[];
	};
	options?: { value: string; label: string }[];
	onSearch?: (value: string, fieldName: FieldName) => void;
	inputValue?: string;
	form?: any;
	disabled?: boolean;
}

const AutoCompleteField = ({
	singleUserInput,
	onSearch,
	options,
	inputValue,
	form,
	disabled = false
}: Props) => {
	const [usesTagsValue, setUsesTagsValue] = useState(form.getFieldValue("usesTags") || "");

	const handleSearch = (value: string) => {
		onSearch?.(value, singleUserInput.name);
	};

	return (
		<div className={styles['input-icon']}>
			<div className={styles['input-icon__title']}>
				<label className={styles['input-icon__title--label']}>
					{singleUserInput.title}
					{singleUserInput.required && (
						<span className="required-color">*</span>
					)}
				</label>
			</div>

			<Form.Item
				name={singleUserInput.name}
				rules={singleUserInput.rules}
				style={{height: '100%'}}
			>
				{singleUserInput.name === "usesTags" ? (
					<AutoComplete
						options={options}
						placeholder={singleUserInput.placeHolder}
						onSearch={handleSearch}
						size="large"
						allowClear
						disabled={disabled}
						className={styles["input-icon__form--input"]}
						filterOption={(inputValue, option) => {
							const usesTags = inputValue.split(",");
							const currentUseTag = usesTags[usesTags.length - 1].trim();

							return (option?.label ?? "")
								.toLowerCase()
								.includes(currentUseTag.toLowerCase());
						}}
						onChange={(val) => {
							setUsesTagsValue(val);
							form.setFieldsValue({ usesTags: val });
						}}
						onSelect={(val) => {
							const parts = usesTagsValue.split(",");
							parts[parts.length - 1] = ` ${val}`;
							const newValue = parts.join(",").replace(/^,/, "").trim();
							setUsesTagsValue(newValue);
							form.setFieldsValue({ usesTags: newValue });
						}}
					/>
				) : (
					<AutoComplete
						options={options}
						placeholder={singleUserInput.placeHolder}
						onSearch={handleSearch}
						size="large"
						allowClear
						disabled={disabled}
						className={styles['input-icon__form--input']}
						filterOption={(inputValue, option) =>
							(option?.label ?? '')
								.toLowerCase()
								.includes(inputValue.toLowerCase())
						}
					/>
				)}
			</Form.Item>
		</div>
	);
};

export default AutoCompleteField;
